<template>
  <div>
    <div class="block_5 flex-col">
          <span class="paragraph_1">
            &ensp;&ensp;&ensp;&ensp;以需求为导向，提供校园经济解决方案。校园外卖“橙子校园”APP、供给自贩机、洗衣系统、热水系统、饮水系统、物流系统、智慧校园等服务，满足学生多元化需求。
            <br />
            &ensp;&ensp;&ensp;&ensp;“橙子校园”由重庆市璧山区攻玉网络科技有限公司开发，2018年9月投入使用，秉承“诚心诚意”的经营理念，经过几年市场反馈进行不断的升级迭代，2021年起橙子校圆平台被纳入市重点平台，2022年自研系统4.0上线，用户突破10万＋，骑手突破1万+。
          </span>
      <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="../assets/img/img9.webp"
      />
    </div>
    <div class="block_6 flex-col">
          <span class="paragraph_2">
            &ensp;&ensp;&ensp;&ensp;"橙子校园”主要服务高校学生，是一个校园020综合生活服务平台。结合智总化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理和校园生活进行充分融合，物联网软硬件结合。
            <br />
            &ensp;&ensp;&ensp;&ensp;在校学生可以在平台进行点餐、购买超市商品、快递代取等业务，采取APP小程序、微信公众号等多端下单方式，实现数据互通；商家在APP端，可以申请注册平台，利用平台进行营业额的增量实现；学生也可以进行自主抢单，平台也可派单，利用空闲时间进行勤工助学。
          </span>
      <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="../assets/img/img10.webp"
      />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        constants: {}
      };
    },
    methods: {}
  };
</script>
<style scoped lang="css" src="../assets/index.css" />
